module.exports = __webpack_public_path__ + "img/avatar_big_5.eda258f5.jpg";